(() => {
  const searchPath = '/search';

  const isHeaderSearchLink = (link) => {
    if (!link || link.closest('search-dropdown')) return false;
    if (!link.closest('.header-section')) return false;

    try {
      const url = new URL(link.href, window.location.origin);
      return url.pathname.replace(/\/$/, '') === searchPath;
    } catch (error) {
      return false;
    }
  };

  const getDrawer = () => document.querySelector('search-dropdown.search-dropdown');

  const openDrawer = (trigger) => {
    const drawer = getDrawer();
    if (!drawer) return;

    customElements.whenDefined('search-dropdown').then(() => {
      drawer.triggerElement = trigger;
      drawer.openDropdown();
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!isHeaderSearchLink(link)) return;

    event.preventDefault();
    event.stopPropagation();
    openDrawer(link);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = getDrawer();
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    drawer.closeDropdown();
  });

  const syncExpandedState = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    const isOpen = drawer.getAttribute('aria-hidden') === 'false';
    document.querySelectorAll('.header-section a[href]').forEach((link) => {
      if (isHeaderSearchLink(link)) {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-expanded', String(isOpen));
      }
    });
  };

  const initialise = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    syncExpandedState();
    new MutationObserver(syncExpandedState).observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
